import { Behaviour, serializable } from "@needle-tools/engine";
import { Material, MeshStandardMaterial, Texture } from "three";
import { RacerEntry } from "./RaceOrderManager";

/**
 * This class manages the racer kits and assigns them to the racers.
 */
export class RacerKitManager extends Behaviour{

    //@serializedField
    sportKey : string = "WHR"; //Web Cam Racing

    /**
     * Added the materials as serializable properties rather than managing RGBs and Hex values directly (This way
     * they can be assiugned in the editor and serialized/deserialized properly.)
     */
    @serializable(Material)
    public blackMaterial! : Material;

    @serializable(Material)
    public blueMaterial! : Material;

    @serializable(Material)
    public lightBlueMaterial! : Material;

    @serializable(Material)
    public greenMaterial! : Material;
    
    @serializable(Material)
    public whiteMaterial! : Material;
    
    @serializable(Material)
    public yellowMaterial! : Material;

    @serializable(Material)
    public redMaterial! : Material;

    @serializable(Material)
    public orangeMaterial! : Material;

    //list of textures for the racers
    @serializable(Texture)
    public racerFlagTextures : Texture[] = [];

    // @serializable(Sprite)
    // public racerSprites : Sprite[] = [];

    // @serializable(Sprite)
    // public argentinaSprite : Sprite | null = null;


    // @serializable(Sprite)
    // public australiaSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public brazilSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public canadaSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public chileSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public denmarkSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public franceSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public germanySprite : Sprite | null = null;

    // @serializable(Sprite)
    // public greatBritainSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public hongKongSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public indiaSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public irelandSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public italySprite : Sprite | null = null;

    // @serializable(Sprite)
    // public japanSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public newZealandSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public peruSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public singaporeSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public southAfricaSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public southKoreaSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public spainSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public swedenSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public turkeySprite : Sprite | null = null;

    // @serializable(Sprite)
    // public unitedArabEmiratesSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public unitedStatesSprite : Sprite | null = null;

    // @serializable(Sprite)
    // public uruguaySprite : Sprite | null = null;



    
    private colorMap: Record<string, { primaryColour: Material, secondaryColour: Material }> | null = null;


    start () {
        this.initializeColorMap();
    }

    /**
     * Initializes the color map with the primary and secondary colors for each country.
     */
    private initializeColorMap() : void {
        this.colorMap = {
            "Argentina": {primaryColour: this.lightBlueMaterial, secondaryColour: this.yellowMaterial},
            "Australia": {primaryColour: this.orangeMaterial, secondaryColour: this.greenMaterial},
            "Brazil": {primaryColour: this.yellowMaterial, secondaryColour: this.greenMaterial},
            "Canada": {primaryColour: this.whiteMaterial, secondaryColour: this.redMaterial},
            "Chile" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Denmark": {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "France": {primaryColour: this.blueMaterial, secondaryColour: this.redMaterial},
            "Germany": {primaryColour: this.whiteMaterial, secondaryColour: this.blackMaterial},
            "Great Britain": {primaryColour: this.blueMaterial, secondaryColour: this.redMaterial},
            "Hong Kong": {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "India" : {primaryColour: this.blueMaterial, secondaryColour: this.orangeMaterial},
            "Ireland": {primaryColour: this.greenMaterial, secondaryColour: this.orangeMaterial},
            "Italy": {primaryColour: this.blueMaterial, secondaryColour: this.greenMaterial},
            "Japan": {primaryColour: this.whiteMaterial, secondaryColour: this.redMaterial},
            "Uruguay": {primaryColour: this.lightBlueMaterial, secondaryColour: this.blackMaterial}, 
            "South Africa": {primaryColour: this.greenMaterial, secondaryColour: this.yellowMaterial},       
            "Spain": {primaryColour: this.redMaterial, secondaryColour: this.yellowMaterial},
            "Sweden": {primaryColour: this.yellowMaterial, secondaryColour: this.blueMaterial},   
            "United Arab Emirates": {primaryColour: this.greenMaterial, secondaryColour: this.redMaterial},
            "United States": {primaryColour: this.whiteMaterial, secondaryColour: this.redMaterial},
            "New Zealand": {primaryColour: this.blackMaterial, secondaryColour: this.whiteMaterial},
            "South Korea": {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Peru" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Singapore": {primaryColour: this.redMaterial, secondaryColour: this.blueMaterial},
            "Turkey": {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Iran": {primaryColour: this.greenMaterial, secondaryColour: this.redMaterial},
            "Afghanistan" : {primaryColour: this.redMaterial, secondaryColour: this.blackMaterial},
            "Algeria" : {primaryColour: this.greenMaterial, secondaryColour: this.whiteMaterial},
            "Bahrain" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Egypt" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Iraq" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Jordan" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Kazakhstan" : {primaryColour: this.lightBlueMaterial, secondaryColour: this.yellowMaterial},
            "Kenya" : {primaryColour: this.redMaterial, secondaryColour: this.greenMaterial},
            "Kuwait" : {primaryColour: this.greenMaterial, secondaryColour: this.redMaterial},
            "Libya" : {primaryColour: this.greenMaterial, secondaryColour: this.whiteMaterial},
            "Morocco" : {primaryColour: this.redMaterial, secondaryColour: this.greenMaterial},
            "Oman" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Pakistan" : {primaryColour: this.greenMaterial, secondaryColour: this.whiteMaterial},
            "Qatar" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Saudi Arabia" : {primaryColour: this.greenMaterial, secondaryColour: this.whiteMaterial},
            "Sudan" : {primaryColour: this.redMaterial, secondaryColour: this.greenMaterial},
            "Syria" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Tunisia" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial},
            "Turkmekistan" : {primaryColour: this.greenMaterial, secondaryColour: this.redMaterial},
            "Yemen" : {primaryColour: this.redMaterial, secondaryColour: this.whiteMaterial}

        }
    }

    public getColorsForCountry(country: string): { primaryColour: Material, secondaryColour: Material } | null {
        if (!this.colorMap) {
            console.error("Color map is not initialized.");
            return null;
        }
        return this.colorMap[country];
    }

    private returnRacerKit(key: string): {primaryColour: Material, secondaryColour: Material} | null {
        let colors = this.getColorsForCountry(key);
        if (!colors) {
            console.error(`No racer kit found for key: ${key}`);
            return null; // Or set default materials here
        }
        colors.primaryColour.vertexColors = true;
        colors.secondaryColour.vertexColors = true;
        return colors;
    }

    /**
     * Assigns the racer kit to relevant components of the racer entry.
     * @param racerEntry The racer entry to assign the kit to.
     */
    public assignRacerKit(racerEntry : RacerEntry) : void {
        this.assignJockeyKit(racerEntry);
        this.assignFlagTexture(racerEntry);
    }

    private assignJockeyKit(racerEntry: RacerEntry) {
        let colors = this.returnRacerKit(racerEntry.racerName);
        if (colors) {
            switch(this.sportKey){
                case "WCR":
                    racerEntry.jockeyRenderer.sharedMaterials[2] = colors.primaryColour;
                    racerEntry.jockeyRenderer.sharedMaterials[3] = colors.secondaryColour;
                    break;

                    case "WHR":
                        racerEntry.jockeyRenderer.sharedMaterials[1] = colors.secondaryColour;
                    racerEntry.jockeyRenderer.sharedMaterials[2] = colors.primaryColour;
                        break;
                default:
                    racerEntry.jockeyRenderer.sharedMaterials[1] = colors.secondaryColour;
                    racerEntry.jockeyRenderer.sharedMaterials[2] = colors.primaryColour;
                    break;
            }
            
        }
    }

    public assignFlagTexture(racerEntry : RacerEntry) : void {
        var countryFlagMaterial = new MeshStandardMaterial({map: this.getRacerFlagTexture(racerEntry.racerName)});

        countryFlagMaterial.color.multiplyScalar(2.0);


        racerEntry.iconRenderer.sharedMaterials[2] = countryFlagMaterial;
    }

    public getRacerFlagTexture(countryName : string) : Texture | null {
        let textureIndex = this.racerFlagTextures.findIndex((texture) => texture.name === countryName);
        if (textureIndex === -1) {
            console.error(`No flag texture found for country: ${countryName}`);
            return null;
        }
        return this.racerFlagTextures[textureIndex];
    }

    // public getRacerSprite(countryName : string) : Sprite | null {
    //     let spriteIndex = this.racerSprites.findIndex((sprite) => sprite.texture?.name === countryName);
    //     if (spriteIndex === -1) {
    //         console.error(`No sprite found for country: ${countryName}`);
    //         return null;
    //     }
    //     return this.racerSprites[spriteIndex];
    // }

}